import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

const url = "https://services1.arcgis.com/ze0XBzU1FXj94DJq/arcgis/rest/services/SAVclass2023_vectorV2/FeatureServer";

const portalId = "2c53ac5eec7041a8990e3d595c74e83f";

export const layer = new FeatureLayer({
  portalItem: {
    id: portalId,
  },
  visible: true,
  title: "Submerged Aquatic Vegetation in Barnegat Bay 2023",
  popupTemplate: {
    title: "Submerged Aquatic Vegetation in Barnegat Bay 2023",
    content: `SAV Class: {gridcode}: see legend for details`,
  },
  layerDescription: "This layer shows likely extent of submerged aquatic vegetation (SAV) of the Barnegat Bay - Little Egg Harbor estuary in New Jersey, USA, for 2023. The SAV map was developed by classifying high resolution airborne digital camera imagery using Object-Based Image Analysis techniques..",
  mapService: url,
  authoritiveSource: `https://rutgers.maps.arcgis.com/home/item.html?id=${portalId}`,
});

export const sav2023 = {layerId: 'sav2023', type: 'layer', item: layer, meta: layer}
